import React from 'react'
import styled from 'styled-components'
import colors from '../styles/colors'
import media from '../styles/media'
// import text from '../styles/text'
import ContentWidth from './ContentWidth';

const StatGrid = ({ content }) => {

  const statCards = content.columns.map(content => 
    <IconContainer>
      <Icon key={content?.icon?.sourceUrl} src={content?.icon?.sourceUrl} alt={content?.icon?.altText} loading="eager"/>
      <IconHeading>{content.headline}</IconHeading>
      <BodyCopy dangerouslySetInnerHTML={{ __html: content.bodyCopy }} />
    </IconContainer>
  )

  return (
    <ContentWidth>
      <GridContainer>
        <HeadingCopy dangerouslySetInnerHTML={{ __html: content.headingCopy }} />
      </GridContainer>
      <StatContainer>
        {statCards}
      </StatContainer>
    </ContentWidth>
  )
}

const GridContainer = styled.div`
    display: flex;
    justify-content: center;
    text-align: center;
    margin-bottom: 3.472vw;

    ${media.fullWidth} {
      margin-bottom: 50px;
    }
    
    ${media.tablet} {
    
    }
    
    ${media.mobile} {
    
    }
`
  const HeadingCopy = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.389vw;
  
  ${media.fullWidth} {
    gap: 20px;
  }

  ${media.tablet} {

  }

  ${media.mobile} {

  }

  p {
    font-size: 1.389vw;
    font-family: Archivo, sans;

    ${media.fullWidth} {
      font-size: 20px;
    }
    
    ${media.tablet} {
      font-size: 2.734vw;
    }
    
    ${media.mobile} {
    
    }
  }

  h2 {
    font-size: 2.778vw;
    font-family: Archivo, sans;
    
    ${media.fullWidth} {
      font-size: 40px;
    }
    
    ${media.tablet} {
      font-size: 3.906vw;
    }
    
    ${media.mobile} {
    
    }
  }
`
const StatContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 62.5vw;

    ${media.fullWidth} {
      width: 900px;
    }
    
    ${media.tablet} {
      justify-content: center;
      width: 100%;
    }
    
    ${media.mobile} {
    
    }
`
const IconContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 1.667vw;
    width: 50%;

    ${media.fullWidth} {
      padding: 24px;
    }
    
    ${media.tablet} {
      width: 38.477vw;
      height: 30.078vw;
    }
    
    ${media.mobile} {
    
    }
`
const Icon = styled.img`
    width: 20.833vw;

    ${media.fullWidth} {
      width: 300px;
    }
    
    ${media.tablet} {
      width: 29.297vw;
    }
    
    ${media.mobile} {
    
    }
`
const IconHeading = styled.h6`
    margin-bottom: 0.556vw;
    margin-top: 0.556vw;
    color: ${colors.grey700};
    font-weight: bold;

    ${media.fullWidth} {
      margin-bottom: 8px;
      margin-top: 8px;
    }
    
    ${media.tablet} {
    
    }
    
    ${media.mobile} {
    
    }
`
const BodyCopy =styled.div`
  p {
    font-family: Archivo, sans;
    font-size: 1.389vw;
    line-height: 2.083vw;
    margin-top: 1.042vw;

    ${media.fullWidth} {
      font-size: 20px;
      line-height: 30px;
      margin-top: 15px;
    }
    
    ${media.tablet} {
      font-size: 2.93vw;
      line-height: 3.516vw;
    }
    
    ${media.mobile} {
    
    }
  }
`

export default StatGrid
